<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-8">
              <div class="card-header pb-0">
                <h6>Device Fingerprint</h6>
                <p class="text-xs text-secondary mb-0">
                  Daftar mesin fingerprint yang terdaftar. Device yang tidak terdaftar atau berstatus Nonaktif akan ditolak saat mengirim data absensi.
                </p>
              </div>
            </div>
            <div class="col-4 float-right">
              <argon-button
                class="mt-4"
                variant="gradient"
                color="success"
                size="sm"
                @click="create()"
              ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add New</argon-button>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2 mt-4">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Nama Device</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Serial Number</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Lokasi</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder">IP Address</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Status</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Sync Terakhir</th>
                    <th class="text-secondary"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in table.data" :key="i">
                    <td class="align-middle text-sm">
                      <span class="text-secondary text-xs font-weight-bold">{{ row.nama_device }}</span>
                    </td>
                    <td class="align-middle text-sm">
                      <span class="text-secondary text-xs">{{ row.device_sn }}</span>
                    </td>
                    <td class="align-middle text-sm">
                      <span class="text-secondary text-xs">{{ row.lokasi || '-' }}</span>
                    </td>
                    <td class="align-middle text-sm">
                      <span class="text-secondary text-xs">{{ row.ip_address || '-' }}</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        class="badge badge-sm"
                        :class="row.status == 'Aktif' ? 'bg-gradient-success' : 'bg-gradient-secondary'"
                      >{{ row.status }}</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        class="badge badge-sm"
                        :class="isOnline(row.last_sync_at) ? 'bg-gradient-success' : 'bg-gradient-danger'"
                      >{{ isOnline(row.last_sync_at) ? 'Online' : 'Offline' }}</span>
                      <p class="text-xs text-secondary mb-0 mt-1">{{ formatLastSync(row.last_sync_at) }}</p>
                      <p class="text-xs text-warning mb-0 mt-1" v-if="row.pending_resync_from" @click="openResync(row)" style="cursor: pointer;">
                        <i class="fa fa-clock" aria-hidden="true"></i> Menunggu device tarik ulang data
                      </p>
                      <p class="text-xs text-warning mb-0 mt-1" v-else-if="row.active_resync_from" @click="openResync(row)" style="cursor: pointer;">
                        <i class="fa fa-eye" aria-hidden="true"></i> Ada data menunggu direview
                      </p>
                    </td>
                    <td>
                      <i class="fa fa-sync-alt fa-sm" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="openResync(row)" title="Tarik Ulang Data"></i>
                      <i class="fas fa-edit fa-sm" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="edit(row)" title="Edit"></i>
                      <i class="fa fa-trash fa-sm" aria-hidden="true" title="Hapus" style="cursor: pointer; margin-right: 20px;" @click="remove(row.id)"></i>
                    </td>
                  </tr>
                  <tr v-if="table.data.length === 0">
                    <td colspan="7" class="text-center text-sm text-secondary py-4">Belum ada device yang terdaftar.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL ADD/EDIT ======= -->
  <div class="container">
    <vue-final-modal v-model="form.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{ form.title }}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="form.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label class="form-control-label mt-3">Nama Device <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Contoh: Mesin Fingerprint Lobby" v-model="dataDevice.nama_device" required>

        <label class="form-control-label mt-3">Serial Number (SN) <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Contoh: BWXP225160090" v-model="dataDevice.device_sn" required>
        <p class="text-xs text-secondary mt-1">
          SN ini harus sama persis dengan yang dikirim mesin fingerprint. Device dengan SN yang belum terdaftar di sini akan ditolak.
        </p>

        <label class="form-control-label mt-3">Lokasi</label>
        <input type="text" class="form-control" placeholder="Contoh: Kantor Pusat - Lobby" v-model="dataDevice.lokasi">

        <label class="form-control-label mt-3">IP Address</label>
        <input type="text" class="form-control" placeholder="Contoh: 192.168.1.201" v-model="dataDevice.ip_address">

        <label class="form-control-label mt-3">Status</label>
        <select class="form-select" v-model="dataDevice.status">
          <option value="Aktif">Aktif</option>
          <option value="Nonaktif">Nonaktif</option>
        </select>

        <label class="form-control-label mt-3">Keterangan</label>
        <textarea class="form-control" placeholder="Catatan tambahan (opsional)" v-model="dataDevice.keterangan"></textarea>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"></div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button variant="gradient" color="secondary" size="sm" width="1" @click="form.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="save()">Save</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
  </div>

  <!-- =======  MODAL TARIK ULANG DATA (RESYNC) ======= -->
  <div class="container">
    <vue-final-modal v-model="formResync.show" classes="modal-container" :content-class="formResync.mode == 'preview' ? 'modal-content-width' : 'modal-content'" :z-index="10000" @update:model-value="onResyncModalToggle">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{ formResync.title }}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="closeResync()"></i>
        </div>
      </div><hr>
      <!-- end header -->

      <!-- STEP 1: pilih rentang tanggal -->
      <div class="modal__content container" v-if="formResync.mode == 'form'">
        <p class="text-xs text-secondary">
          Meminta device mengirim ulang data absen yang tersimpan di mesin untuk rentang tanggal berikut. Berguna kalau internet sempat mati tapi karyawan tetap berhasil tap jari, dan datanya belum masuk ke server. Data yang ditarik akan ditampilkan dulu untuk direview sebelum dimasukkan ke database, jadi tidak akan tercatat dobel.
        </p>
        <label class="form-control-label mt-3">Dari Tanggal <span style="color: red;">*</span></label>
        <input type="date" class="form-control" v-model="dataResync.from" required>

        <label class="form-control-label mt-3">Sampai Tanggal <span style="color: red;">*</span></label>
        <input type="date" class="form-control" v-model="dataResync.to" required>

        <p class="text-xs text-secondary mt-3">
          Selama menunggu balasan device, tap jari secara live tetap masuk otomatis seperti biasa &mdash; hanya data lama sesuai rentang tanggal ini yang ditahan untuk direview. Fitur ini belum pernah diuji ke perangkat fisik asli &mdash; sebaiknya dicoba di luar jam kerja aktif terlebih dahulu.
        </p>
      </div>

      <!-- STEP 2: menunggu balasan device -->
      <div class="modal__content container text-center py-4" v-if="formResync.mode == 'waiting'">
        <i class="fa fa-spinner fa-spin fa-2x text-info" aria-hidden="true"></i>
        <p class="text-sm text-secondary mt-3 mb-0">Menunggu device melakukan polling berikutnya dan mengirim data...</p>
        <p class="text-xs text-secondary">Ini bisa memakan waktu beberapa saat tergantung interval polling device. Modal ini akan otomatis menampilkan data begitu tersedia.</p>
      </div>

      <!-- STEP 3: preview data sebelum dimasukkan -->
      <div class="modal__content container" v-if="formResync.mode == 'preview'">
        <p class="text-xs text-secondary">
          Ditemukan <strong>{{ resyncPreview.rows.length }}</strong> baris data dari device.
          <span class="text-danger" v-if="resyncDuplicateCount > 0">{{ resyncDuplicateCount }} di antaranya sudah ada di database (akan dilewati otomatis, tidak akan dobel).</span>
        </p>
        <div class="table-responsive p-0 scroll">
          <table class="table align-items-center mb-0 table-hover-row">
            <thead>
              <tr style="background-color: #F0F8FF;">
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Karyawan</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Tanggal</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Jam</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in resyncPreview.rows" :key="i">
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.nama_karyawan || row.pin }}</span>
                  <p class="text-xs text-secondary mb-0" v-if="row.nama_karyawan">{{ row.pin }}</p>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs">{{ moment(row.date).format('D MMM YYYY') }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs">{{ row.time }}</span>
                </td>
                <td class="align-middle text-center">
                  <span class="badge badge-sm bg-gradient-danger" v-if="row.is_duplicate">Sudah Ada (Dilewati)</span>
                  <span class="badge badge-sm bg-gradient-success" v-else>Baru</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"></div>
        <template v-if="formResync.mode == 'form'">
          <div class="col-2" style="margin-right: 20px;">
            <argon-button variant="gradient" color="secondary" size="sm" width="1" @click="closeResync()">Close</argon-button>
          </div>
          <div class="col-1">
            <argon-button variant="gradient" color="success" size="sm" width="1" @click="saveResync()">Kirim</argon-button>
          </div>
        </template>
        <template v-else-if="formResync.mode == 'waiting'">
          <div class="col-2" style="margin-right: 20px;">
            <argon-button variant="gradient" color="danger" size="sm" width="1" @click="cancelResyncData()">Batalkan</argon-button>
          </div>
          <div class="col-1">
            <argon-button variant="gradient" color="secondary" size="sm" width="1" @click="closeResync()">Tutup</argon-button>
          </div>
        </template>
        <template v-else-if="formResync.mode == 'preview'">
          <div class="col-2" style="margin-right: 20px;">
            <argon-button variant="gradient" color="danger" size="sm" width="1" @click="cancelResyncData()">Batalkan</argon-button>
          </div>
          <div class="col-1">
            <argon-button variant="gradient" color="success" size="sm" width="1" @click="confirmResyncData()">Masukkan ke Database</argon-button>
          </div>
        </template>
      </div>
      <!-- end footer -->
    </vue-final-modal>
  </div>
</template>

<script>
var moment = require('moment');
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import device from '@/services/device.service';
import akun from '@/services/akun.service';

export default {
  name: "device",
  components: {
    ArgonButton,
    VueFinalModal,
  },
  data() {
    return {
      moment: moment,
      table: {
        data: []
      },
      form: {
        title: "Add Data",
        show: false
      },
      dataDevice: {},
      formResync: {
        title: "Tarik Ulang Data Absen",
        show: false,
        mode: 'form', // 'form' | 'waiting' | 'preview'
      },
      dataResync: {},
      resyncPreview: { rows: [] },
      resyncPollTimer: null,
      role: '',
    };
  },
  computed: {
    resyncDuplicateCount() {
      return this.resyncPreview.rows.filter(function(r) { return r.is_duplicate; }).length;
    },
  },
  mounted() {
    this.get();
    this.getRole();
  },
  beforeUnmount() {
    this.stopResyncPolling();
  },
  methods: {
    get() {
      let context = this;
      Api(context, device.index()).onSuccess(function(response) {
        context.table.data = response.data.data;
      }).onError(function(error) {
        if (error.response && error.response.status == 404) {
          context.table.data = [];
        } else {
          context.notify('Gagal memuat data device', 'error')
        }
      })
      .call()
    },
    getRole() {
      let context = this;
      Api(context, akun.indexProfile()).onSuccess(function(response) {
        context.role = response.data.data[0].role;
        if (response.data.data[0].role != 'Admin') {
          context.$router.push({ path: '/detail-profile/'+response.data.data[0].employee_id})
        }
      }).onError(function(error) {})
      .call()
    },
    isOnline(lastSyncAt) {
      if (!lastSyncAt) return false;
      return moment().diff(moment(lastSyncAt), 'seconds') < 60;
    },
    formatLastSync(lastSyncAt) {
      if (!lastSyncAt) return 'Belum pernah sync';
      return moment(lastSyncAt).fromNow();
    },
    create() {
      this.form.show  = true;
      this.form.title = "Add Data";
      this.dataDevice = { status: 'Aktif' };
    },
    edit(row) {
      this.dataDevice = { ...row };
      this.form.show  = true;
      this.form.title = 'Edit Data';
    },
    save() {
      let api      = null;
      let context  = this;
      let formData = new FormData();

      if (context.dataDevice.nama_device && context.dataDevice.device_sn) {
        formData.append('nama_device', context.dataDevice.nama_device);
        formData.append('device_sn', context.dataDevice.device_sn);
        formData.append('lokasi', context.dataDevice.lokasi || '');
        formData.append('ip_address', context.dataDevice.ip_address || '');
        formData.append('status', context.dataDevice.status || 'Aktif');
        formData.append('keterangan', context.dataDevice.keterangan || '');
      } else {
        return alert('Field Bintang Merah Wajib Di Isi')
      }

      if (context.form.title == 'Add Data') {
        api = Api(context, device.create(formData));
      } else {
        api = Api(context, device.update(context.dataDevice.id, formData));
      }
      api.onSuccess(function() {
        context.get();
        context.form.show = false;
        context.notify(context.form.title == 'Add Data' ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      }).onError(function(error) {
        if (error.response && error.response.data && error.response.data.data && error.response.data.data.device_sn) {
          context.notify(error.response.data.data.device_sn[0], 'error')
        } else {
          context.notify('Data Gagal di Simpan', 'error')
        }
      })
      .call();
    },
    openResync(row) {
      this.dataResync    = { id: row.id, from: moment().format('YYYY-MM-DD'), to: moment().format('YYYY-MM-DD') };
      this.resyncPreview = { rows: [] };
      this.formResync.show = true;

      // A review session from an earlier visit may still be open (command
      // already sent, or data already staged) -- jump straight to checking
      // instead of asking for a date range again.
      if (row.pending_resync_from || row.active_resync_from) {
        this.formResync.mode = 'waiting';
        this.startResyncPolling();
      } else {
        this.formResync.mode = 'form';
      }
    },
    onResyncModalToggle(isOpen) {
      if (!isOpen) {
        this.stopResyncPolling();
      }
    },
    closeResync() {
      this.formResync.show = false;
      this.stopResyncPolling();
    },
    saveResync() {
      let context = this;

      if (!context.dataResync.from || !context.dataResync.to) {
        return alert('Field Bintang Merah Wajib Di Isi')
      }
      if (context.dataResync.to < context.dataResync.from) {
        return alert('Tanggal "Sampai" tidak boleh sebelum tanggal "Dari"')
      }

      Api(context, device.requestResync(context.dataResync.id, {
        from: context.dataResync.from,
        to: context.dataResync.to,
      })).onSuccess(function() {
        context.get();
        context.formResync.mode = 'waiting';
        context.startResyncPolling();
      }).onError(function(error) {
        if (error.response && error.response.data && error.response.data.data && error.response.data.data.to) {
          context.notify(error.response.data.data.to[0], 'error')
          return
        }
        context.notify('Gagal mengirim permintaan tarik ulang data', 'error')
      })
      .call();
    },
    startResyncPolling() {
      let context = this;
      context.checkResyncPreview();
      context.stopResyncPolling();
      context.resyncPollTimer = setInterval(function() {
        context.checkResyncPreview();
      }, 5000);
    },
    stopResyncPolling() {
      if (this.resyncPollTimer) {
        clearInterval(this.resyncPollTimer);
        this.resyncPollTimer = null;
      }
    },
    checkResyncPreview() {
      let context = this;
      Api(context, device.getResyncPreview(context.dataResync.id)).onSuccess(function(response) {
        context.resyncPreview = response.data.data;
        if (context.resyncPreview.rows.length > 0) {
          context.formResync.mode = 'preview';
          context.stopResyncPolling();
        }
      })
      .call();
    },
    confirmResyncData() {
      let context = this;
      Api(context, device.confirmResync(context.dataResync.id)).onSuccess(function(response) {
        context.get();
        context.formResync.show = false;
        context.stopResyncPolling();
        context.notify('Berhasil dimasukkan: ' + response.data.data.inserted + ' data baru, ' + response.data.data.skipped + ' dilewati karena sudah ada', 'success')
      }).onError(function() {
        context.notify('Gagal memasukkan data ke database', 'error')
      })
      .call();
    },
    cancelResyncData() {
      let context = this;
      Api(context, device.cancelResync(context.dataResync.id)).onSuccess(function() {
        context.get();
        context.formResync.show = false;
        context.stopResyncPolling();
        context.notify('Permintaan tarik ulang data dibatalkan', 'success')
      }).onError(function() {
        context.notify('Gagal membatalkan permintaan', 'error')
      })
      .call();
    },
    remove(id) {
      var r = confirm("Anda yakin ingin menghapus device ini ?");
      if (r == true) {
        let context = this;
        Api(context, device.delete(id)).onSuccess(function() {
          context.get();
          context.notify('Data Successfully Deleted', 'success')
        }).onError(function() {
          context.notify('Gagal menghapus device', 'error')
        }).call();
      }
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, { autoClose: 2000 });
      } else {
        toast.error(message, { autoClose: 2000 });
      }
    },
  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  max-width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
  margin-top: auto;
  margin-bottom: auto;
}
::v-deep .modal-content-width {
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  max-width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
.scroll {
  overflow: auto;
  max-height: 60vh;
  border: 1px solid #eef0f4;
  border-radius: 0.75rem;
}
.table-hover-row tbody tr:hover {
  background-color: #f8f9fa;
}
</style>
